import React from 'react'
import "./Home_about_us.css";

const Home_about_us = () => {
    return (
        <section className='about_section' >
            <div className='container py-3'>
                <div className='img_holder'>
                    <div className='image_1'>
                        <img src='./assets/images/home/home_about_us/Banner_img.png' className='banner_img' />
                    </div>

                    <div className='text_div'>
                        <h2 className='about_title'>ABOUT US</h2>
                        <p className='about_subtitle'>
                            A trusted recharge and payments platform built to make your
                            digital transactions simple, fast, and secure.
                        </p>
                    </div>
                </div>

                <div className='about_text'>
                    <p >
                        We are a rapidly growing digital recharge and payments platform dedicated to transforming
                        the way people manage their everyday transactions. Our goal is to make every payment experience
                        seamless, secure, and highly convenient, removing the hassle of multiple apps and complicated
                        processes.
                    </p>
                    <p >
                        With our app, users can effortlessly handle all their payment
                        needs in one place from mobile recharges and DTH top-ups to FASTag recharges,
                        utility bill payments, and more.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Home_about_us